import { useContext, useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {
    SttContainer,
    SttTranslateHook
} from '@stt-componentes/core';
import { SttButton } from '@stt-componentes/core-v2';
import DadosExame from './dados-exame';

const Visualizacao = (props) => {

    const { imprimirFn, imprimirProtocoloFn, imprimirTermoFn } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const [idExame, setIdExame] = useState(null);

    useEffect(() => {
        if (id) {
            navigate('/exames', { replace: true });
            navigate('/exames/visualizar', { state: { exame: Buffer.from(id, 'base64').toString('utf-8') } });
        }

        if (location.state?.exame) {
            setIdExame(location.state.exame);
        }

    }, [location.state?.exame]);

    const voltar = () => {
        navigate('/exames', { state: { from: 'visualizar' } });
    }

    return (
        <div>
            {
                idExame &&
                <DadosExame
                    id={idExame}
                    imprimirFn={imprimirFn}
                    imprimirProtocoloFn={imprimirProtocoloFn}
                    imprimirTermoFn={imprimirTermoFn}
                    voltarFn={voltar}
                />
            }
        </div>
    )
}

export default Visualizacao;